import Vue from 'vue';
import App from './App';
import store from './store'
import { router } from './router';
import { Dialog ,Toast} from 'vant';
import {TextSpeaker} from '@/utils/textSpeaker';
import '@/styles/index.scss' // global css

Vue.use(Dialog);
Vue.use(Toast);


import parseConfigValue from '@/plugin/parseConfigValue.js'
Vue.use(parseConfigValue)
Vue.use({
  install: function(Vue) {
    Vue.prototype.$textSpeaker = new TextSpeaker();
  }
});



const vm = new Vue({
  router,
  el: '#app',
  store,
  render: h => h(App)
});

export default vm
